import { render, staticRenderFns } from "./dashboardJournalAdsUnit.vue?vue&type=template&id=92bf8f78&scoped=true&"
import script from "./dashboardJournalAdsUnit.vue?vue&type=script&lang=js&"
export * from "./dashboardJournalAdsUnit.vue?vue&type=script&lang=js&"
import style0 from "./dashboardJournalAdsUnit.vue?vue&type=style&index=0&id=92bf8f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bf8f78",
  null
  
)

export default component.exports